/* Sis You're Crowned For This
   Puts The Word into the header menu and the mobile drawer.

   The header is a web component: its markup lives inside a <template> and is
   cloned into an open shadow root at load. That is why editing the Shopify
   menus does nothing to it. This adds the Bible links to the real header the
   moment it hydrates, and stays quiet if the header ever changes shape. */
(function () {
  var DESKTOP =
    '<a href="/pages/bible">The Word</a>' +
    '<div class="menu">' +
      '<a href="/pages/bible">Read the Bible<small>free, the whole thing</small></a>' +
      '<a href="/pages/bible#syc-plans">Reading plans<small>fifteen, for the season you are in</small></a>' +
      '<a href="/pages/bible#syc-yours">Your Word<small>your highlights and notes</small></a>' +
    '</div>';

  var DRAWER =
    '<span class="grp">The Word</span>' +
    '<a href="/pages/bible">Read the Bible</a>' +
    '<a href="/pages/bible#syc-plans">Reading plans</a>' +
    '<a href="/pages/bible#syc-yours">Your Word</a>';

  function place() {
    var host = document.querySelector('syc-block[data-t="syc-t-header"]');
    if (!host || !host.shadowRoot) return false;
    var r = host.shadowRoot;
    if (r.querySelector('[data-syc-word]')) return true;

    var ul = r.querySelector('.nav ul');
    if (!ul) return false;

    var li = document.createElement('li');
    li.className = 'dd';
    li.setAttribute('data-syc-word', '');
    li.innerHTML = DESKTOP;
    ul.insertBefore(li, ul.firstChild);

    var drawer = r.querySelector('.drawer');
    var firstGroup = drawer && drawer.querySelector('.grp');
    if (firstGroup) {
      var wrap = document.createElement('div');
      wrap.setAttribute('data-syc-word', '');
      wrap.style.display = 'contents';
      wrap.innerHTML = DRAWER;
      firstGroup.parentNode.insertBefore(wrap, firstGroup);
    }

    // mark it as the current page when she is reading
    if (location.pathname.indexOf('/pages/bible') === 0) {
      var a = li.querySelector('a');
      if (a) a.className = 'on';
    }
    return true;
  }

  if (place()) return;
  var tries = 0;
  var t = setInterval(function () {
    if (place() || ++tries > 80) clearInterval(t);
  }, 100);
})();